module.exports = __webpack_public_path__ + "static/media/share-button.6aa83405.svg";